<template>
    <transition name="fade">
        <div class="card">
            <div class="left">
                <h3 class="card-title">{{ data.title }}</h3>
                <div class="card-body" v-if="data.description">
                    {{ data.description }}
                </div>
                <div class="card-footer">
                    Updated {{ data.updated }}
                </div>
            </div>
            <div class="right">
                <a :href="data.link?.url ? data.link.url : data.document.url" :target="data?.link?.target ? data.link.target : (data.document ? '__blank' : '')" class="btn btn-primary">{{ data.link?.title ? data.link.title : "View Form" }}</a>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        data: Object
    },
    data () {
        return {
        }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.card {
    padding: 32px 40px;
    background-color: #0B3148;
    border-radius: 5px;
    display: flex;
    gap: 8px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @include xl {
        flex-direction: column;
        align-items: initial;
    }

    .left {
        width: 100%;
        flex: 5;
    }

    .right {
        flex: 2;
        display: flex;
        justify-content: flex-end;

        @include xl {
            justify-content: flex-start;
            margin-top: 24px;
        }
    }

    .card-title {
        color: #fff;
        font-size: 20px;
        font-family: "Paralucent Demi";

        @include xl {
            font-size: 18px;
        }
    }

    .card-body {
        color: #fff;
        font-size: 14px;
    }

    .card-footer {
        color: #C7932C;
        font-size: 12px;
        margin-top: 20px;
        font-family: "Paralucent Demi";
    }
}
</style>